import React from "react";
import "./RequestDetailModal.css";

const RequestDetailModal = ({
    open,
    onClose,
    data,
    showActions = false,     // mặc định không có 2 nút
    onApprove,
    onReject
}) => {

    if (!open || !data) return null;

    return (
        <div className="reqdetail-overlay">
            <div className="reqdetail-modal">

                {/* Header */}
                <div className="reqdetail-header">
                    <h3>Thông tin chi tiết yêu cầu</h3>
                    <span className="reqdetail-close" onClick={onClose}>✕</span>
                </div>

                {/* Nội dung */}
                <div className="reqdetail-body">

                    {/* Nhóm thông tin chung */}
                    <div className="reqdetail-section">
                        <h4>Thông tin chung</h4>

                        <div className="reqdetail-row">
                            <label>Loại yêu cầu:</label>
                            <span>{data.loaiYeuCau}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>Loại giao dịch:</label>
                            <span>{data.loaiGiaoDich}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>Chi nhánh:</label>
                            <span>{data.chiNhanh}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>Thời gian tạo:</label>
                            <span>{data.thoiGianTao}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>User tạo:</label>
                            <span>{data.userTao}</span>
                        </div>
                    </div>

                    {/* Nhóm thông tin ĐLTT / User */}
                    <div className="reqdetail-section">
                        <h4>Thông tin ĐLTT / User</h4>

                        <div className="reqdetail-row">
                            <label>ID ĐLTT / User:</label>
                            <span>{data.idDLTTUser}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>CIF ĐLTT:</label>
                            <span>{data.cifDLTT}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>Tên ĐLTT:</label>
                            <span>{data.tenDLTT}</span>
                        </div>

                        <div className="reqdetail-row">
                            <label>TKTT giao dịch:</label>
                            <span>{data.tktt}</span>
                        </div>
                    </div>

                    {/* Lý do */}
                    {data.lyDo && (
                        <div className="reqdetail-section">
                            <h4>Lý do</h4>
                            <div className="reqdetail-reason">{data.lyDo}</div>
                        </div>
                    )}
                </div>

                {/* FOOTER BUTTONS — chỉ hiển thị ở trang chờ xử lý */}
                {showActions && (
                    <div className="reqdetail-footer">
                        <button className="btn-reject" onClick={onReject}>Từ chối</button>
                        <button className="btn-approve" onClick={onApprove}>Duyệt</button>
                    </div>
                )}

            </div>
        </div>
    );
};

export default RequestDetailModal;
